import styled from '@emotion/styled'
import { Link } from 'react-router-dom'

const FormFooter = () => {
	return (
		<Footer>
			<FooterItem>
				<SignupLink to="/signup">회원가입</SignupLink>
			</FooterItem>
			<FooterItem>{/* <SignupLink to="/signup">비밀번호 찾기</SignupLink> */}</FooterItem>
		</Footer>
	)
}

const Footer = styled.div`
	margin-top: 1rem;
	display: flex;
	justify-content: space-between;
`
const FooterItem = styled.div``
const SignupLink = styled(Link)`
	text-decoration: none;
	font-size: 14px;
`

export default FormFooter
